import { useEffect, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { interviewerApi } from '../../lib/api/interviewer'

export default function CalendlyCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')

    if (error || !code || !state) {
      navigate('/interviewer/schedule?calendly=error', { replace: true })
      return
    }

    const run = async () => {
      try {
        // Step 1: Complete OAuth on backend (GET with JWT Bearer token)
        await interviewerApi.connectCalendly(code, state)

        // Step 2: Fetch event types from Calendly (backend already auto-selects on OAuth,
        // this is a safety net in case the backend call failed)
        try {
          const eventData = await interviewerApi.getEventTypes()
          const eventTypes: { uri: string; duration: number; active: boolean }[] =
            eventData?.event_types ?? []
          const activeTypes = eventTypes.filter((e) => e.active)
          // Prefer 60-min event type; fallback to first active
          const chosen =
            activeTypes.find((e) => e.duration === 60) ?? activeTypes[0]
          if (chosen?.uri) {
            await interviewerApi.setCalendlyEventType(chosen.uri)
          }
        } catch {
          // Non-critical — backend already handled auto-select during OAuth
        }

        navigate('/interviewer/schedule?calendly=connected', { replace: true })
      } catch {
        navigate('/interviewer/schedule?calendly=error', { replace: true })
      }
    }

    run()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        color: 'var(--text-muted)',
        fontSize: 15,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid var(--border)',
          borderTopColor: 'var(--primary-navy)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      Connecting your Calendly account…
    </div>
  )
}
